import { Controller } from "@hotwired/stimulus";
import { useTransition } from "stimulus-use";

export default class extends Controller {
  static targets = ["menu", "triggerChevron"];

  connect() {
    useTransition(this, {
      element: this.menuTarget,
    });
  }

  toggle() {
    this.toggleTransition();
    if (this.hasTriggerChevronTarget) {
      this.triggerChevronTarget.classList.toggle("rotate-180");
    }
  }

  hide(event) {
    if (
      !this.element.contains(event.target) &&
      !this.menuTarget.classList.contains("hidden")
    ) {
      this.leave();
    }
  }
}
